/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPublicServicesOutput } from "../../entities/models/PublicServicesOutput";
import { modelsPublicServiceOutputSchema } from "./publicServiceOutputSchema";
import { z } from "zod/v4";

export const modelsPublicServicesOutputSchema = z.object({
    get "services"(){
                return z.array(modelsPublicServiceOutputSchema).optional()
              }
    }) as unknown as z.ZodType<ModelsPublicServicesOutput>